module.exports = __webpack_public_path__ + "static/media/signal-alt-3.f2c08d25.svg";